import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import ThemeMainMenu from './ThemeMainMenu'
import SideBar from '../sidebar/SideBar'
import MobileMenu from './MobileMenu'

const ThemeMenuTwo = () => {
    const [sticky, setSticky] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false)
    const [menu, setMenu] = useState('')

    const openSidebar = () => {
        setShowSidebar(true)
    }
    const closeSidebar = () => {
        setShowSidebar(false)
    }
    const showMobilemenu = () => {
        setMenu('show')
    }
    const hideMobilemenu = () => {
        setMenu()
    }

    useEffect(() => {
        const stickyMenu = () => {
            setSticky(window.scrollY >= 60)
        }

        window.addEventListener('scroll', stickyMenu, { passive: true })
        stickyMenu()

        return () => {
            window.removeEventListener('scroll', stickyMenu)
        }
    }, [])

    return (
        <Fragment>
            <SideBar onClick={closeSidebar} value={showSidebar} />
            <header className="theme-main-menu theme-menu-two py-lg-4">
                <div className={sticky ? 'main-header-area sticky-menu' : 'main-header-area'}>
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xxl-3 col-xl-2 col-lg-2 col-6 text-start">
                                <div className="logo-area">
                                    <Link to="/" aria-label="CODAM 홈">
                                        <img
                                            src="/assets/img/logo/codam-logo.svg"
                                            alt="CODAM 로고"
                                            style={{ maxHeight: '42px', width: 'auto' }}
                                        />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 d-none d-lg-block">
                                <nav className="navbar navbar-expand-lg">
                                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                        <ThemeMainMenu />
                                    </div>
                                </nav>
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-6 text-end">
                                <ul className="right-nav mb-0 d-flex align-items-center justify-content-end">
                                    <li>
                                        <div className="hamburger-menu">
                                            <div className="d-none d-lg-inline-block">
                                                <a className="round-menu" href="#" onClick={openSidebar}>
                                                    <i className="bi bi-list" />
                                                </a>
                                            </div>
                                            <a className="round-menu d-lg-none" href="#" onClick={showMobilemenu}>
                                                <i className="bi bi-list" />
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <MobileMenu onClick={hideMobilemenu} active={menu} />
            </header>
        </Fragment>
    )
}

export default ThemeMenuTwo
